module.exports = "/images/Small Business-Hero.jpg";